/**
 *
 * @param {string} phoneNumber
 * @returns {boolean}
 */
export function validatePhoneNumber(phoneNumber) {
  if (phoneNumber.length === 17 && phoneNumber.startsWith('+1 ')) {
    phoneNumber = phoneNumber.slice(3)
  }
  const regex = /^\(\d{3}\) \d{3}-\d{4}$/
  if (regex.test(phoneNumber)) {
    return true
  }
  return false
}
